import Vue from 'vue'
export default {
  fetch (status, page) {
    return Vue.http.get(window.API_URL + 'doctors/appointment_requests?status=' + status + '&page=' + page)
  },
  approve (id, doctorId) {
    return Vue.http.put(window.API_URL + 'doctors/appointment_requests/' + id, {doctor_status: 'Approved', doctor_id: doctorId})
  },
  reject (id, doctorId) {
    return Vue.http.put(window.API_URL + 'doctors/appointment_requests/' + id, {doctor_status: 'Rejected', doctor_id: doctorId})
  },
  furtherTesting (id, doctorId) {
    return Vue.http.put(window.API_URL + 'doctors/appointment_requests/' + id, {doctor_status: 'further_testing', doctor_id: doctorId})
  },
  saveComment (id, comment, doctorId) {
    return Vue.http.put(window.API_URL + 'doctors/appointment_requests/' + id, {doctor_comments: comment, doctor_id: doctorId})
  },
  search (query) {
    return Vue.http.get(window.API_URL + 'doctors/appointment_requests/search?q=' + query)
  },
  reschedule (payload) {
    return Vue.http.patch(window.API_URL + 'doctors/customers/appointment_requests/' + payload.id, payload)
  }
}



// WEBPACK FOOTER //
// ./src/api/appointment_request.js